__turbopack_context__.v({
  "container": "_7-IU5q_container",
  "slide": "_7-IU5q_slide",
  "viewport": "_7-IU5q_viewport",
  "wrapper": "_7-IU5q_wrapper",
});
